/** Grymwyrd deutsche Texte für den Home-Hero. */
export const homeDe = {
  'home.heroEyebrow': 'Eine lebendige Horror-Fantasy-Welt',
  'home.heroTitle': 'Tritt ein ins Zwielicht',
  'home.heroBody':
    'Grymwyrd ist eine gaslichterhellte Welt viktorianischen Gothic-Horrors, in der die nebelversunkene Stadt Greywick verfallene Türme, Kellergewölbe von Herrenhäusern und Rituale verbirgt, die man besser unausgesprochen lässt. Schmiede dir einen Helden, lüfte die Schleier des Kataklysmus und ritze deinen Namen in eine Welt, die sich erinnert.',
  'home.heroPlayCta': 'Jetzt spielen',
  'home.heroBrowseCta': 'Enzyklopädie durchstöbern',
  'home.heroQuickstartPrompt': 'Noch nicht bereit zu spielen? Hol dir das kostenlose Quickstart',
}
